module.exports = __webpack_public_path__ + "static/media/pic_404.faa247a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/redirect/pic_404.svg
// module id = 697
// module chunks = 0